<template>
  <div class="discount" @click.stop="$emit('click')">
    <div><div>優惠類別:</div><div><span v-if="discount.ID">[{{discount.ID}}]</span> {{mode}}</div></div>
    <div><div>優惠名稱:</div> <div>{{discount.name}}</div></div>
    <div><div>可用區域:</div> <div class="toolong" :style="{width: ''}">{{discount.store.join(' | ')}}</div></div>
    <div v-if="discount.mode===4||discount===5"><div>指定項目:</div> <div class="toolong2">{{discount.specify.map(e => e.name).join(' / ')}}</div></div>
    <div v-if="discount.mode===1"     ><div>折扣內容:</div><div>滿{{discount.cond}}元 折<span :style="{color:'var(--highlight)', fontWeight: '900'}"> {{discount.disc}} </span>元</div></div>
    <div v-else-if="discount.mode===2"><div>折扣內容:</div><div>每{{discount.cond}}元 折<span :style="{color:'var(--highlight)', fontWeight: '900'}"> {{discount.disc}} </span>元</div></div>
    <div v-else-if="discount.mode===3"><div>折扣內容:</div><div>滿{{discount.cond}}元 打<span :style="{color:'var(--highlight)', fontWeight: '900'}"> {{discount.disc}} </span>折</div></div>
    <div v-else-if="discount.mode===4"><div>折扣內容:</div><div>指定項目折 <span :style="{color:'var(--highlight)', fontWeight: '900'}"> {{discount.disc}} </span>元</div></div>
    <div v-else-if="discount.mode===5"><div>折扣內容:</div><div>指定項目打<span :style="{color:'var(--highlight)', fontWeight: '900'}"> {{discount.disc}} </span>折</div></div>
    <div v-else-if="discount.mode===6"><div>折扣內容:</div><div>現金禮券<span :style="{color:'var(--highlight)', fontWeight: '900'}"> {{discount.disc}} </span>元</div></div>
    <div v-else-if="discount.mode===7"><div>折扣內容:</div><div>指定項目折 <span :style="{color:'var(--highlight)', fontWeight: '900'}"> {{discount.disc}} </span>元</div></div>
    <div><div>有效時間:</div> <div>{{toDate(discount.startTime)}} ~ {{toDate(discount.expireTime)}}</div></div>
  </div>
</template>

<script>
export default {
  props: ['discount'],
  computed: {
    mode () {
      switch (this.discount.mode) {
        case 7:
          return '全部指定商品折抵'
        case 6:
          return '禮券'
        case 5:
          return '指定商品折抵'
        case 4:
          return '指定商品折扣'
        case 3:
          return '滿額折扣'
        case 2:
          return '滿額折抵(累進)'
        default:
          return '滿額折抵'
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.discount {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1em 3em;
  text-align: start;
  border: 1px solid #CACACA;
  border-radius: 10px;
  &>div{
    display: flex;
    align-items: flex-start;
    font-size: 20px;
    line-height: 32px;
    letter-spacing: .1em;
    &>div:nth-child(1) {
      width: 6em;
    }
    &>div:nth-child(2) {
      width: 420px;
    }
  }
}
</style>
